module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper', {
    ref: "mySwiper",
    staticClass: "content",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide'), _vm._v(" "), _c('swiper-slide', [_c('h2', [_vm._v("HAKKIMIZDA")])]), _vm._v(" "), _c('swiper-slide', [_c('h2', [_vm._v("FAALİYET ALANLARI")])]), _vm._v(" "), _c('swiper-slide', [_c('h2', [_vm._v("EKİBİMİZ")])]), _vm._v(" "), _c('swiper-slide', [_c('h2', [_vm._v("YAYINLAR")])]), _vm._v(" "), _c('swiper-slide', [_c('h2', [_vm._v("İLETİŞİM")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a0b3593","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/swiperx.vue
// module id = 54
// module chunks = 0